export default [
    {
        path: '/platinum-widgets',
        props: true,
        component: () => import('@/views/PlatinumWidget'),
    },
    {
        path: '/platinum-widgets/:id',
        props: true,
        component: () => import('@/views/PlatinumWidget/Show'),
    },
];
